import { atom } from "recoil";


export const selectedTagsState = atom({
    key: 'selectedTagsState',
    default: []
});